import { PERMISSIONS, ROLES } from "app/constants";
import { useAppSelector } from "app/hooks";
import { selectProfilePermissions, selectProfileRole } from "./profileSlice";

export default function useAccess() {
  const role = useAppSelector(selectProfileRole);
  const permissions = useAppSelector(selectProfilePermissions);

  function hasRoles(roles: ROLES | ROLES[], roleList?: string[]) {
    const _roles = roleList || role;
    if (!_roles) {
      return false;
    }
    if (typeof roles === "string") {
      return _roles.includes(roles);
    } else {
      return !!roles.find(function (value) {
        return _roles.includes(value);
      });
    }
  }
  function hasPermissions(permission: PERMISSIONS | PERMISSIONS[]) {
    if (!permissions) {
      return false;
    }
    if (typeof permission === "string") {
      return permissions.includes(permission);
    } else {
      return permission.some(function (value) {
        return permissions.indexOf(value) >= 0;
      });
    }
  }
  return {
    hasRoles,
    hasPermissions,
  };
}
